/**
 * Popup dialogs.
 *
 * Triggers carry data-diakon-popup with the popup's ID; lib/blocks/popup.php
 * prints the matching <dialog> in the footer. showModal() brings the top layer,
 * focus trapping, Escape and focus restoration with it, so this only has to
 * open the right one and close on the two gestures the browser leaves to us.
 */

const TRIGGER = '[data-diakon-popup]';
const DIALOG = '.diakon-popup';

export function initPopups() {
	document.addEventListener('click', (event) => {
		const trigger = event.target.closest(TRIGGER);

		if (!trigger) {
			return;
		}

		const dialog = document.getElementById(
			`diakon-popup-${trigger.dataset.diakonPopup}`
		);

		if (!dialog) {
			return;
		}

		event.preventDefault();
		dialog.diakonOpener = trigger;
		dialog.showModal();
	});

	document.querySelectorAll(DIALOG).forEach((dialog) => {
		// The dialog element itself is only ever the target on the backdrop:
		// its inner wrapper covers the box, padding included.
		dialog.addEventListener('click', (event) => {
			if (event.target === dialog) {
				dialog.close();
			}
		});

		dialog
			.querySelector('.diakon-popup__close')
			?.addEventListener('click', () => dialog.close());

		// The browser returns focus to whatever had it when this dialog
		// opened. After a donation popup swapped for another, that was a
		// field in the dialog swapped away, so the button that opened the
		// first one takes it instead. Not while another dialog is open: this
		// one closed because the other took its place.
		dialog.addEventListener('close', () => {
			const opener = dialog.diakonOpener;

			if (
				opener?.isConnected &&
				!document.querySelector(`${DIALOG}[open]`)
			) {
				opener.focus();
			}
		});
	});
}
